import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles-module.css';
import { ACTIVE, INACTIVE, SHOW_ALL } from '../consts';

const StatusFilter = (props) => {
  const { stateOnFilterChange, queryOnFilterChange, selectedStatus, customClass } = props;

  const filterDivideClasses = (index) => {
    const filterDivideSelectedClasses = `${styles.filterDivide} ${styles.filterDivideSelected}`;
    if (index === 0 && (selectedStatus === SHOW_ALL || selectedStatus === ACTIVE)) {
      return filterDivideSelectedClasses;
    }
    else if (index === 1 && (selectedStatus === ACTIVE || selectedStatus === INACTIVE)) {
      return filterDivideSelectedClasses;
    }
    return styles.filterDivide;
  }

  return (
    <div className={`${styles.buttonBar} ${customClass}`}>
      <div
        role='button'
        tabIndex={0}
        className={`${styles.button} ${selectedStatus === SHOW_ALL && styles.active}`}
        onClick={() => {
          stateOnFilterChange(SHOW_ALL);
          queryOnFilterChange(SHOW_ALL);
        }}
      >
        <FormattedMessage
          id="add-ons.all"
          defaultMessage="All"
          description="All Add-ons both active and inactive"
        />
      </div>
      <span className={filterDivideClasses(0)} />
      <div
        role='button'
        tabIndex={0}
        className={`${styles.button} ${selectedStatus === ACTIVE && styles.active}`}
        onClick={() => {
          stateOnFilterChange(ACTIVE);
          queryOnFilterChange(ACTIVE);
        }}
      >
        <FormattedMessage
          id="add-ons.active"
          defaultMessage="Active"
          description="Add-ons that are active at the moment"
        />
      </div>
      <span className={filterDivideClasses(1)} />
      <div
        role='button'
        tabIndex={0}
        className={`${styles.button} ${selectedStatus === INACTIVE && styles.active}`}
        onClick={() => {
          stateOnFilterChange(INACTIVE);
          queryOnFilterChange(INACTIVE);
        }}
      >
        <FormattedMessage
          id="add-ons.inactive"
          defaultMessage="Inactive"
          description="Add-ons that are inactive at the moment"
        />
      </div>
    </div>
  );
};

export default StatusFilter;
